import { ApolloClient, InMemoryCache, gql, ApolloQueryResult } from '@apollo/client';

const SUBGRAPH_MAP: { [network: string]: string } = {
  1: 'https://api.thegraph.com/subgraphs/name/ourzora/zora-v1',
  4: 'https://api.thegraph.com/subgraphs/name/ourzora/zora-v1-rinkeby',
};

const fetchGraph = async <T, V>(
  chainId: number,
  query: string,
  variables?: V,
): Promise<ApolloQueryResult<T>> => {
  const client = new ApolloClient({
    uri: SUBGRAPH_MAP[chainId],
    cache: new InMemoryCache(),
  });

  return client.query<T, V>({
    query: gql(query),
    variables,
  });
};

export default fetchGraph;
